var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.SuggestableTagsView = function (superClass) {
  extend(SuggestableTagsView, superClass);
  function SuggestableTagsView() {
    return SuggestableTagsView.__super__.constructor.apply(this, arguments);
  }
  SuggestableTagsView.prototype.initialize = function (options) {
    if (options == null) {
      options = {};
    }
    this.tagOptions = options.tag_options;
    this.sortable = options.sortable;
    SuggestableTagsView.__super__.initialize.apply(this, arguments);
    return this.listenTo(this.collection, 'add remove sort', this.render, this);
  };
  SuggestableTagsView.prototype.render = function () {
    this.setupTagViews();
    this.initSortable();
    if (this.onChange) {
      this.onChange();
    }
    return this;
  };
  SuggestableTagsView.prototype.setupTagViews = function () {
    _.invoke(this.tagViews, 'remove');
    this.tagViews = this.collection.map(function (_this) {
      return function (m) {
        return _this.viewForModel(m);
      };
    }(this));
    return _.each(this.tagViews, function (_this) {
      return function (view) {
        return _this.$el.append(view.render().el);
      };
    }(this));
  };
  SuggestableTagsView.prototype.initSortable = function () {
    if (!this.sortable) {
      return;
    }
    this.$('li').each(function (_this) {
      return function (index, el) {
        return $(el).data('sort-index-of-model', _this.collection.at(index));
      };
    }(this));
    return this.$el.sortable({
      containment: 'document',
      items: 'li',
      placeholder: 'list-pill-placeholder bg-white',
      start: function (_this) {
        return function () {
          return _this.closePopovers();
        };
      }(this),
      update: function (_this) {
        return function (e, ui) {
          return _this.handleSortingUpdate(e, ui);
        };
      }(this)
    });
  };
  SuggestableTagsView.prototype.handleSortingUpdate = function (e, ui) {
    this.$('li').each(function (i, el) {
      var model;
      model = $(el).data('sort-index-of-model');
      model.set('display_order', i);
      return model.set('last_dragged', false);
    });
    ui.item.data('sort-index-of-model').set('last_dragged', true);
    return this.collection.sort();
  };
  SuggestableTagsView.prototype.closePopovers = function () {
    return this.$('.popover').each(function (i, el) {
      return $(el).data('bs.popover').$element.popover('hide');
    });
  };
  SuggestableTagsView.prototype.viewForModel = function (model) {
    return new Works.SuggestableTagView(_({
      model: model
    }).extend(this.tagOptions));
  };
  SuggestableTagsView.prototype.remove = function () {
    _.invoke(this.tagViews, 'remove');
    return SuggestableTagsView.__super__.remove.apply(this, arguments);
  };
  return SuggestableTagsView;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;